import { Stack, Typography, TypographyVariant } from '@mui/material';
import { Category } from '@modules/common/types';
import { capitalize } from 'lodash';
import { CategoryIcon } from '../CategoryIcon/CategoryIcon';

interface CategoryLabelTooltipNodeProps {
  category: Category;
  iconSize?: number;
  labelVariant?: TypographyVariant;
  text?: string | JSX.Element;
}

export const CategoryLabelTooltipNode = ({
  category,
  text,
  labelVariant = 'caption',
  iconSize = 16,
}: CategoryLabelTooltipNodeProps) => {
  return (
    <Stack direction="row" spacing={0.5}>
      <Stack mt={0.25}>
        <CategoryIcon category={category} size={iconSize} />
      </Stack>
      <Typography variant={labelVariant}>
        {capitalize(category)}: {text}
      </Typography>
    </Stack>
  );
};
